




























































































































































import Vue from 'vue'
import LabelStatus from '../../../../components/LabelStatus.vue'
import KkiapayVerificationModal from '@/apps/FNM/components/KkiapayVerificationModal.vue'
import api from '../../../../api'

export default Vue.extend({
  components: {
    LabelStatus,
    KkiapayVerificationModal
  },

  data() {
    return {
      hideSearchInput: true,
      showRapportModal: false,
      search: '',
      loading: false,
      downloadLoading: false,
      refreshTimer: null as number | null,
      selectedField: '',
      selectedCredit: null as any,
      credits: [] as any[],
      downloadElements: [
        { title: 'Rapport complet', value: '' },
        { title: 'Rapport succes', value: 'succeeded' },
        { title: 'Rapport echec', value: 'failed' },
        { title: 'Rapport en attente', value: 'pending' }
      ],
      columns: [
        { label: 'N° de dossier', field: 'reference', sortable: false },
        { label: 'NPI', field: 'beneficiary.npi', sortable: false },
        { label: 'Nom', field: 'beneficiary.name', sortable: false },
        { label: 'Sexe', field: 'beneficiary.gender', sortable: false },
        { label: 'N° MoMo', field: 'beneficiary.phone', sortable: false },
        { label: 'Montant', field: 'amount', sortable: false },
        { label: 'Agence', field: 'agency', sortable: false },
        { label: 'Statut', field: 'state', sortable: false },
        { label: 'Actions', field: '_actions', sortable: false, align: 'right' }
      ]
    }
  },

  computed: {
    dispatchingId(): string {
      return this.$route.params.dispatchingId
    },

    fieldTitles(): any[] {
      return [
        { title: 'Tout', value: '', total: this.credits.length },
        {
          title: 'Succes',
          value: 'succeeded',
          total: this.credits.filter((c: any) => c.state === 'succeeded').length
        },
        {
          title: 'En attente',
          value: 'pending',
          total: this.credits.filter((c: any) => c.state === 'pending').length
        },
        {
          title: 'Echec',
          value: 'failed',
          total: this.credits.filter((c: any) => c.state === 'failed').length
        }
      ]
    },

    filteredCredits(): any[] {
      let result = this.credits
      if (this.selectedField) {
        result = result.filter((c: any) => c.state === this.selectedField)
      }
      if (this.search) {
        const s = this.search.toUpperCase()
        result = result.filter(
          (c: any) =>
            c.beneficiary?.name?.toUpperCase().includes(s) ||
            c.beneficiary?.phone?.includes(this.search)
        )
      }
      return result
    }
  },

  methods: {
    async fetchCredits() {
      try {
        const { data } = await api.get(
          `/dispatching-credits/dispatching/${this.dispatchingId}?populate=beneficiary`
        )
        this.credits = Array.isArray(data) ? data : data.result || data
      } catch (err) {
        console.error(err) // eslint-disable-line
      }
    },

    searchIconClick() {
      this.hideSearchInput = !this.hideSearchInput
    },

    changeStatus(status: string) {
      this.selectedField = status
    },

    downloadReport(status: string) {
      this.downloadLoading = true
      const titles: Record<string, string> = {
        '': 'Rapport de dispatching complet',
        succeeded: 'Rapport de dispatching reussi',
        failed: 'Rapport de dispatching echoue',
        pending: 'Rapport de dispatching en attente'
      }
      api
        .download(
          `/dispatching-credits/download/dispatching-report/${this.dispatchingId}?status=${status}`,
          {},
          `${titles[status] || 'Rapport'}.xlsx`
        )
        .then(() => {
          this.downloadLoading = false
        })
        .catch(() => {
          this.downloadLoading = false
        })
    },

    openVerification(credit: any) {
      this.selectedCredit = credit
    },

    onVerificationSuccess() {
      this.selectedCredit = null
      this.fetchCredits()
    }
  },

  mounted() {
    this.loading = true
    this.fetchCredits().then(() => {
      this.loading = false
    })

    this.refreshTimer = setInterval(() => {
      this.fetchCredits()
    }, 5000) as any
  },

  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }
})
